import Partners from '../../components/Partners/Partners';
import Benefits from '../../components/Benefits/Benefits';
import Payments from '../../components/Payments/Payments';
import { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import PopUp from '../../components/PopUp/PopUp';
import { FormData } from '../../types/types';
import Button from '../../components/Button/Button';

const About = () => {
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const handleSubmit = (formData: FormData) => {
    console.log(formData);
    setIsOpen(false);
  };
  return (
    <>
      <Payments openModal={openModal} />
      <Benefits children='Contact us' openModal={openModal} />
      <Partners startIndex={0} />
      {isRequestSent ? (
        <Modal
          isOpen={isRequestSent}
          onClose={() => setIsRequestSent(false)}
          className='thank-popup popup'
          title='Thank you!'
        >
          <p className='popup__text text-large '>
            Your request has been successfully sent.
          </p>
          <p className='popup__text text-large '>
            Our expert will contact you soon.
          </p>
          <Button
            className='popup__button'
            type='button'
            onClick={() => setIsRequestSent(false)}
          >
            Close
          </Button>
        </Modal>
      ) : (
        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          className='popup'
          title='Share your request with our sales team'
        >
          <PopUp
            className='form-popup'
            onSubmit={handleSubmit}
            setIsOpen={setIsOpen}
            setIsRequestSent={setIsRequestSent}
          />
        </Modal>
      )}
    </>
  );
};
export default About;
